<template>
  <v-list class="pa-0">
    <v-list-item
      v-for="(item, index) in sleeps"
      :key="item.sleepId || index"
      class="border-bottom"
    >
      <div class="d-flex align-center justify-space-between w-100 py-2">
        <div class="d-flex align-center">
          <p class="mb-0">{{ minuteFormat(item.from) }} 〜 {{ minuteFormat(item.to) }}</p>
        </div>

        <div class="d-flex">
          <v-btn icon variant="text" color="red" @click="deleteItem(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </div>
    </v-list-item>
  </v-list>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import Swal from 'sweetalert2';
import { t } from '@/i18n';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');

import { dailyReportModule } from '@/store/entityModules/dailyReport';

import { SleepResponse } from '@API/src/component/home/sleep/types';
/*
import {
  SwipeList,
  SwipeOut,
} from 'vue-swipe-actions';
 */
import { Toast } from '@/service/SweetAlert';
//import 'vue-swipe-actions/dist/vue-swipe-actions.css';
import { SwipeListModel } from '@/model/SwipeList/SwipeList';

export default defineComponent({

  components: {
    //SwipeOut,
    //SwipeList,
  },

  props: {
    sleeps: {
      type: Array,
      default: () => ([]),
    },
  },

  computed: {
    swipeList(): SwipeListModel {
      return (this.$refs as any).sleep_swipe_list;
    },
  },

  methods: {
    minuteFormat(iso: string) {
      return dayjs(iso).format('HH:mm');
    },
    revealFirstRight(index, revealed) {
      if (!revealed) {
        this.swipeList.revealRight(index);
      } else {
        this.swipeList.closeActions(index);
      }
    },
    revealFirstLeft() {
      this.swipeList.revealLeft(0);
    },
    closeFirst() {
      this.swipeList.closeActions(0);
    },
    closeAll() {
      this.swipeList.closeActions();
    },
    async deleteItem(e: SleepResponse) {
      Swal.fire({
        title: `<span style="font-size: 23px;">${t('record.confirm.deleteRecord', '記録を削除しますか?')}</span>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#FF3F3A',
        cancelButtonColor: '#BDBDBD',
        confirmButtonText: t('common.delete', '削除'),
        cancelButtonText: t('common.cancel', 'キャンセル'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          Swal.showLoading();
          await dailyReportModule.deleteSleep({ sleepId: e.sleepId });
          Toast.fire({
            icon: 'success',
            title: t('record.toast.deleted', '削除が完了しました'),
          });
        }
      });
    },
    itemClick(e) {},
    fbClick(e) {},
    sbClick(e) {},
  },

});
</script>
<style lang="scss" scoped>

</style>
